<template>
    <div class="stockWrap">
        <p class="title">{{ $t('aside.name') }}</p>
        <div class="stockBody">
			<img src="http://image.sinajs.cn/newchart/min/n/sh600398.gif" style="width:100%" />
        </div>
    </div>
</template>
<script>
export default {
    name:'stock'
}
</script>
<style lang="scss" scoped>
    .stockWrap{
        .title{
            font-size: 0.24rem;
            font-weight: bold;
            color: #161A1A;
            margin-top: 0.4rem;
            text-align: center;
        }
        .stockBody{
            margin-top: 0.64rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/notice/stock.vue